import React from 'react'
import { Link } from 'react-router-dom'
const SignUp = () => {
    return (
        <div className="signInUp">
            <div className="signInUp__wrapper">
            <div className="signInUp__wrapper__buttons signInUp__wrapper__buttons--signup">
                    <form action="#">
                        <input type="text"  className="inputAlpha" placeholder="Nome" />
                        <input type="text" className="inputAlpha" placeholder="Sobrenome" />
                        <input type="email" className="inputAlpha" placeholder="Email" />
                        <input type="password" className="inputAlpha" placeholder="Senha" />
                    </form>
                    <Link to="/login" className="defaultBtn">Cadastrar</Link>
                    <Link to="/login" className="defaultLink">Já tem conta? Entre.</Link>
                </div>
            </div>
        </div>
    )
}

export default SignUp
